import { CircleAlertIcon } from "lucide-react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";

export function MatrixErrorCard({ message }: { message: string }) {
  return (
    <Alert variant="destructive">
      <CircleAlertIcon />
      <AlertTitle>Failed to load matrix</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
